import axios from 'axios';
import { baseUrl } from 'config';
import axiosInstance from 'utils/https';

export const UploadReportFile = async (credentials) => {
    const res = await axiosInstance().post(`/compliance/upload_any_report/`, credentials, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return res?.data;
};

export const GetBusinessUser = async (id) => {
    const res = await (id
        ? axios.get(`${baseUrl}/user_mgt/business_user/${id ? `${id}/` : ''}`)
        : axiosInstance().get(`/user_mgt/business_user/${id ? `${id}/` : ''}`));
    return id ? res?.data : res;
};

export const UpdateBusinessUser = async (credentials) => {
    const res = await axiosInstance().patch(`/user_mgt/business_user/`, credentials, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return res?.data;
};
